
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '~/store/modules/user';

@Component({})
export default class DeleteEmptyHomes extends Vue {
    isDialogOpen = false;

    async deleteEmptyHomes(): Promise<void> {
        await UserModule.deleteEmptyHomes();
        this.isDialogOpen = false;
    }

    get userMail(): string {
        return UserModule.userMail;
    }
}
